export enum CreateMode {
  P, // create P wave
  QRS, // create QRS wave
  QRST, // create QRS + T wave
  T, // create T wave
  calibration, // create calibration wave
  artifact, // create artifact wave
  noise, // create noise wave
  no_signal, // create no signal wave
  p_level_noise, // create P level noise wave
  qrs_level_noise, // create QRS level noise wave
  pt_level_noise, // create PT-level noise wave
  uncertain, // create uncertain wave
  microvolted, // create microvolted wave
  X, // delete wave
}
